export function SearchIcon({ size = 18 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle
        cx="84"
        cy="84"
        r="52"
        fill="none"
        stroke="currentColor"
        strokeWidth="14"
      />
      <line
        x1="122"
        y1="122"
        x2="172"
        y2="172"
        stroke="currentColor"
        strokeWidth="14"
        strokeLinecap="square"
      />
    </svg>
  );
}
